<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <!-- v2 replaces these floating guides with the setup cards on the Today screen -->
  @if (!v2On) {
    <app-setup-guide-widget></app-setup-guide-widget>
    <app-payments-guide-widget></app-payments-guide-widget>
  }
</ion-app>
